module.exports = __webpack_public_path__ + "static/media/receta-03.b427147c.png";